<template>
  <div class="actu-playstation-page container">
    <div>
      <TheBreadcrumb :pages="arianeRoute" />
      <HeaderPage :page="currentPageInfo" />
      <div class="order">
        <section
          v-if="metaContent?.description"
          class="section order-last"
        >
          <div
            class="description"
            v-html="metaContent.description"
          />
        </section>
        <div class="order-first">
          <SearchResults :with-search="false">
            <template #title>
              <h2 class="title-strat">Dernières actualités PlayStation</h2>
            </template>
            <template #results>
              <ActuPlaystationContainer :items="actualities" />
            </template>
          </SearchResults>
          <ThePagination
            :total-pages="actualitiesPages"
            :current-page="actualitiesCurrentPage"
            :go-to="changePageTo"
          />
          <DoNotMissSection
            v-if="doNotMiss.length"
            :slider-items="doNotMiss"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()

definePageMeta({
  middleware: useLoadActualitiesWAP,
})

const actualitiesWapStore = useActualitiesWAPStore()
const metaContentStore = useMetaContentStore()

const { actualities, actualitiesPages, actualitiesCurrentPage } =
  storeToRefs(actualitiesWapStore)

const link = useLinkPrevNext({
  currentPage: actualitiesCurrentPage,
  pagesCount: actualitiesPages,
})

const arianeRoute = [
  {
    title: "Toute l'actualité PlayStation",
    route: '',
  },
]

const breadcrumbSchema = useBreadcrumbSchema({
  arianeRoute,
})

useHead({
  title: 'Actus PlayStation : Sortie PS5, exclus, News Jeux Vidéos...',
  link,
  script: [breadcrumbSchema],
})

useSeoMeta({
  title: 'Actus PlayStation : Sortie PS5, exclus, News Jeux Vidéos...',
  description:
    "Soyez au courant des dernières infos sur les jeux vidéo du moment. Partagez vos actualités et vos bons plans sur vos jeux favoris. Rejoignez la communauté WAP pour plus d'informations.",
  ogTitle: 'Toute l’actualité PlayStation',
  ogDescription:
    'Soyez au courant des dernières infos sur les jeux vidéo du moment.',
  ogImage: 'https://www.weareplaystation.fr/img/toute-l-actu-playstation.jpg',
})

const { doNotMiss } = storeToRefs(useDoNotMissStore())

const currentPageInfo = {
  title: "Toute l'actualité PlayStation",
  image: '/img/toute-l-actu-playstation.jpg',
  titleSmall: "toute l'actualité",
  titleBig: 'PlayStation',
  description:
    'Soyez au courant des dernières infos sur les jeux vidéo du moment.',
}

const metaContent = computed(() => {
  return metaContentStore.getTransverseBySlug(route.name).value
})

const changePageTo = async (index = 1) => {
  if (index > 0) {
    await actualitiesWapStore.fetchActualities({
      page: index,
    })
  }
}
</script>

<style lang="scss" scoped>
.actu-playstation-page {
  min-height: 100vh;
  padding-bottom: 10rem;

  .title-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.order {
  display: flex;
  flex-direction: column;

  &-first {
    order: 1;
  }

  &-last {
    order: 2;
    width: 100%;
  }

  .description {
    &:deep(h2) {
      margin-bottom: 1.5rem;
    }

    &:deep(h3) {
      margin-bottom: 1rem;
      font-family: SST;
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 2rem;
      letter-spacing: 0.225rem;
      text-transform: uppercase;
    }

    &:deep(p) {
      margin-bottom: 1rem;
    }

    &:deep(ul) {
      margin-bottom: 1rem;
      padding-left: 1em;
      list-style: disc;
    }
  }
}
</style>
